import React from 'react';
import CreateApplication from '../components/admin/CreateApplication';

const CreateApplicationPage = () => {
  return <CreateApplication />;
};

export default CreateApplicationPage;

